import React, { useEffect, useState, createContext, useContext } from 'react';
import { CguModal } from './CguModal';


const CGU_ACCEPTED_KEY = 'cguAccepted';

const CguContext = createContext(undefined);

export const useCgu = () => {
  const context = useContext(CguContext);
  if (!context) {
    throw new Error('useCgu must be used within a CguProvider');
  }
  return context;
};

export const CguProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(CGU_ACCEPTED_KEY);
    if (accepted !== 'true') {
      setShowModal(true);
    }
  }, []);

  //Adding a class when modal is opened to counter sidebar z-index
  useEffect(() => {
    if (showModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [showModal]);

  const handleAccept = () => {
    localStorage.setItem(CGU_ACCEPTED_KEY, 'true');
    setShowModal(false);
  };

  const contextValue = {
    showCguModal: () => setShowModal(true),
  };

  return (
    <CguContext.Provider value={contextValue}>
      {children}
      {showModal && <CguModal onAccept={handleAccept} />}
    </CguContext.Provider>
  );
};
